<div class="action-modal">
  <div class="action-modal__header">
    <span class="action-modal__title">Action On {{component.Name}}</span>
    <i class="material-icons action-modal__close-button" (click)="onNoClick()" matTooltip="Close Popup">close</i>
  </div>
  <div class="inventory-modal__body">
    <div>
      <mat-form-field class="input">
        <mat-select style="align-content: center" (selectionChange)="actionChanged($event)"  [(ngModel)]="action.ActionTypeId"
          placeholder="{{Translate('Action')}}">
          <mat-option *ngFor="let action of availableActions" [value]="action.ActionTypeId">
            {{ action.ActionTypeName }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    <div *ngIf="isReplaceWithNewAction" [@fadeInOut]>
      <div>
        <mat-form-field class="input">
          <mat-select (selectionChange)="replacementCompartChanged($event)"  [(ngModel)]="action.ReplaceComponentCompartId"
            placeholder="{{Translate('Compartment')}}">
            <mat-option *ngFor="let compart of availableCompartments" [value]="compart.Id">
              {{ compart.Name }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <div>
          <mat-form-field class="input">
            <input matInput placeholder="{{'Times Re-builded / Re-grousered/ Re-sealed ' | translate | async}}" type="number"   [(ngModel)]="action.Reed">
          </mat-form-field>
        </div>
      <!-- <div>
        <mat-form-field class="input">
          <mat-select (selectionChange)="replacementCompartChanged($event)" name="action" [(ngModel)]="action.BrandId"
            placeholder="{{Translate('Compartment')}}">
            <mat-option *ngFor="let compart of availableCompartments" [value]="action.ReplaceCompartment">
              {{ compart.Name }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div> -->
      <div>
        <mat-form-field class="input">
          <input matInput placeholder="{{'Budget Life' | translate | async}}" type="number" [(ngModel)]="action.BudgetLife">
        </mat-form-field>
      </div>

      <div>
        <mat-form-field class="input">
          <mat-select  [(ngModel)]="action.MakeId"
              placeholder="{{Translate('Make')}}">
              <mat-option *ngFor="let make of Makes" [value]="make.Id">
                {{ make.Title }}
              </mat-option>
            </mat-select>
        </mat-form-field>
      </div>

    </div>


  </div>
  <div>
      <mat-form-field class="input">
        <input matInput placeholder="{{'Actions At Cmu' | translate | async}}" type="number" [(ngModel)]="action.NewSMU">
      </mat-form-field>
    </div>

  <div *ngIf=" +action.ActionTypeId === 10302 || +action.ActionTypeId === 10203">
      <mat-form-field class="input">
        <input matInput placeholder="{{'How long Budget Life will be extended' | translate | async}}" type="number" [(ngModel)]="action.ExtendedBudgetLife" >
      </mat-form-field>
  </div>


  <div *ngIf="+action.ActionTypeId === 10602 || +action.ActionTypeId === 17 || +action.ActionTypeId === 10702">
      <mat-form-field  class="action-input" *ngIf="allRollers?.length >= 1">
          <mat-select name="Roller To Swap" placeholder="{{'Select Swap component' | translate | async}}">
            <mat-option *ngFor="let roller of allRollers"  (click)="swapRollerEvent(roller)" [value]="roller">
              {{ roller.Name }}  {{ roller.Position }}
            </mat-option>
          </mat-select>
        </mat-form-field>
        <div style="margin-left: 25px; color: orange;" *ngIf="allRollers?.length <= 1 || allRollers === null || allRollers === undefined"> {{'Note : There are not enough same type of rollers to swap position with on this system' | translate | async}} </div>
    <!-- <mat-form-field class="action-input">
      <mat-select (selectionChange)="selectedComponentReplacement($event)"  name="replacement"  name= "'Select available replacement'" placeholder="{{Translate('Select available replacement')}}">
          <mat-option *ngFor="let replacement of availableComponentReplacements" [value]="replacement">
              {{ replacement.Name }}
          </mat-option>
      </mat-select>
    </mat-form-field> -->
  </div>

  <div *ngIf="showCost">
      <mat-form-field class="input">
        <input matInput placeholder="{{'Cost' | translate | async}}" type="number" [(ngModel)]="action.Cost">
      </mat-form-field>
  </div>
  <div *ngIf="!showCost">
    <mat-form-field class="input">
      <input matInput placeholder="{{'Part Cost' | translate | async}}" type="number" [(ngModel)]="action.PartCost">
    </mat-form-field>
  </div>

    <div>
      <mat-form-field class="input">
        <mat-select (selectionChange)="labourCostOptionChanged($event)"  [(ngModel)]="action.LabourCostOption"
          placeholder="{{Translate('Labour Cost Option')}}">
          <mat-option *ngFor="let op of LabourCostOptions" [value]="op.Id">
            {{ op.Name }}
          </mat-option>
        </mat-select>
      </mat-form-field>
      <div *ngIf="action.LabourCostOption == 1   && cutomerHourlyRate != 0"> Customer hourly rate : $ {{cutomerHourlyRate}} </div>
      <mat-form-field class="input"  *ngIf="needToInputHourlyRate">
        <input matInput placeholder="{{ 'Customer Hourly Rate' | translate | async}}" type="number" [(ngModel)]="action.HourlyRate">
      </mat-form-field>
    </div>

    <div *ngIf="!showCost">
      <mat-form-field class="input">
        <input matInput placeholder="{{ labourCostLableTitle | translate | async}}" type="number" [(ngModel)]="action.LabourCost">
      </mat-form-field>
    </div>

    <div *ngIf="!showCost">
      <mat-form-field class="input">
        <input matInput placeholder="{{'Misc Cost' | translate | async}}" type="number" [(ngModel)]="action.MiscCost">
      </mat-form-field>
    </div>
    <div> Total Cost : {{currentTotalCost() | currency }}</div>
    <div>
      <mat-form-field class="input">
        <input matInput [matDatepicker]="myDatepicker" placeholder="Date of Action" [(ngModel)]="action.ActionDate"
          [formControl]="date" readonly>
        <mat-datepicker-toggle matSuffix [for]="myDatepicker"></mat-datepicker-toggle>
        <mat-datepicker #myDatepicker></mat-datepicker>
      </mat-form-field>
    </div>

    <div>
      <mat-form-field class="input">
        <textarea matInput placeholder="Comment" [(ngModel)]="action.Comment"></textarea>
      </mat-form-field>
    </div>



    <div class="ttmodal__footer">
      <button mat-raised-button (click)="onNoClick()">Cancel</button>
      <button mat-raised-button color="warn" [class.loading]="saving" (click)="RecordAction()" [disabled]="Buttondisabled">
        <span class="material-icons button__icon">check</span>
        <span class="button__text">{{'Record Action'| translate | async}}</span>
      </button>
    </div>
  
    <div style="margin-top: 5px;"></div>
  </div>
